/**
 * Whether a `?returnTo=` value is safe to navigate to after login - a
 * same-origin relative path only. Blocks protocol-relative ("//host") and
 * absolute-URL open-redirect vectors, since this value comes from a query
 * param an attacker could craft a link with.
 */
export function isSafeReturnTo(value: string | null): value is string {
  if (!value) return false;
  return value.startsWith('/') && !value.startsWith('//');
}
